const Home = ({ width = 22, height = 19.65, color = 'currentColor', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 20H4C3.73478 20 3.48043 19.8947 3.29289 19.7071C3.10536 19.5196 3 19.2653 3 19V10H0L10.327 0.612042C10.5111 0.44452 10.7511 0.351685 11 0.351685C11.2489 0.351685 11.4889 0.44452 11.673 0.612042L22 10H19V19C19 19.2653 18.8946 19.5196 18.7071 19.7071C18.5196 19.8947 18.2652 20 18 20ZM5 18H17V8.15704L11 2.70304L5 8.15704V18ZM8 9.00004H14V15H8V9.00004ZM10 11V13H12V11H10Z"
        fill={color}
      />
    </svg>
  )
}

export default Home
